interface HasLabel {
  label: string;
}

const priority_values = ['null', 'low', 'medium', 'high'];

export const byPriority = (a?: HasLabel, b?: HasLabel) => {
  const a_label = (a?.label ?? 'null').toLowerCase();
  const b_label = (b?.label ?? 'null').toLowerCase();

  const a_index = priority_values.indexOf(a_label);
  const b_index = priority_values.indexOf(b_label);

  return a_index === b_index ? 0 : a_index > b_index ? 1 : -1;
};
